export default class Hero {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {}
}
